export const widgetName = 'social-share';
export const widgetDisplayName = 'Social share';
export const widgetCategory = 'CMS';
export const widgetSelector = 'social-share';
export const widgetRuntimeSelector = 'social-share-runtime';
export const widgetEditorSelector = 'social-share-editor';